import { useState } from "react";

import * as Api from "@/api";
import GoTo from "@/app/shared/GoTo";
import Avatar from "@/design/components/Avatar";
import useGoTo from "@/utils/hooks/useGoTo";
import Valkyrie, { viSpinnerThird, viTrashCan } from "@sippy-platform/valkyrie";

import { IconButton, ListItem, ListItemAvatar, ListItemButton, ListItemText, Typography } from "@mui/material";
import PropTypes from "prop-types";

function OptionButton({ ivr, ivrOption, ivrDispatch, setActiveIvrOption, activeIvrOption }) {
  const { getGoTo } = useGoTo();

  const [processing, setProcessing] = useState(false);

  function deleteOption() {
    setProcessing(true);

    Promise.resolve(Api.deleteIvrOption(ivr, ivrOption))
      .then(() => {
        ivrDispatch({ type: "deleteOption", option: ivrOption });

        if (activeIvrOption.id === ivrOption.id) {
          setActiveIvrOption(null);
        }
      })
      .finally(() => setProcessing(false));
  }

  return (
    <ListItem
      disablePadding
      key={ivrOption.input}
      secondaryAction={
        ivrOption.id && (
          <IconButton onClick={deleteOption}>
            <Valkyrie icon={processing ? viSpinnerThird : viTrashCan} spin={processing} />
          </IconButton>
        )
      }
    >
      <ListItemButton
        selected={activeIvrOption?.input === ivrOption.input}
        onClick={() => setActiveIvrOption(ivrOption)}
        id={`option${ivrOption.input}`}
      >
        <ListItemAvatar>
          <Avatar text={ivrOption.input} main />
        </ListItemAvatar>
        <ListItemText
          primary={
            ivrOption?.id ? (
              ivrOption.forceCallerId ? (
                <>
                  {ivrOption.forceCallerId} (
                  <GoTo target={getGoTo(ivrOption.overflow)} hideType />)
                </>
              ) : (
                <GoTo target={getGoTo(ivrOption.overflow)} hideType />
              )
            ) : (
              "Empty"
            )
          }
          secondary={
            ivrOption?.id ? (
              ivrOption.announcement ? (
                <>
                  {ivrOption.overflow ? <GoTo target={getGoTo(ivrOption.overflow)} type /> : "None"} &middot;{" "}
                  <Typography component="span" variant="body2" style={{ fontSize: ".75rem" }} color="textPrimary">
                    {ivrOption.announcement.name}
                  </Typography>
                </>
              ) : ivrOption.overflow ? (
                <GoTo target={getGoTo(ivrOption.overflow)} type />
              ) : (
                "None"
              )
            ) : (
              "Click to set up"
            )
          }
        />
      </ListItemButton>
    </ListItem>
  );
}

OptionButton.propTypes = {
  ivr: PropTypes.object,
  ivrOption: PropTypes.object,
  setActiveIvrOption: PropTypes.func,
  activeIvrOption: PropTypes.object,
  ivrDispatch: PropTypes.func,
};

export default OptionButton;
